import React, { useState } from "react";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";
import { _post } from "../../../Utils/Helper";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/reducers";
import { Spinner } from "react-bootstrap";
import FeatherIcon from "feather-icons-react";

interface Form {
    student_name: string;
  current_class: string;
  admission_no: string;
  home_address: string;
  date_of_birth: string;
  sex: string;
  religion: string;
  tribe: string;
  state_of_origin: string;
  l_g_a: string;
  special_health_needs: string;
  blood_group: string;
  academic_year: string;
  primary_contact_number: string;
  mother_tongue: string;
  language_known: string;
  section: string;
  parent_id: string;
}

const _form: Form = {
  student_name: "",
  current_class: "",
  admission_no: "",
  home_address: "",
  date_of_birth: "",
  sex: "",
  religion: "",
  tribe: "",
  state_of_origin: "",
  l_g_a: "",
  special_health_needs: "",
  blood_group: "",
  academic_year: "",
  primary_contact_number: "",
  mother_tongue: "",
  language_known: "",
  section: "",
  parent_id: "",
};

interface compProps {
    setStudents: any;
}

const BulkUploadStudents: React.FC<compProps> = ({setStudents}) => {
  const [formArray, setFormArray] = useState<Form[]>([]);
    const [loading, setLoading] = useState(false);
    const {user,selected_branch} = useSelector((state: RootState) => state.auth);
  // Generate Excel Template
  const generateTemplate = () => {
    const fields = Object.keys(_form);
    const ws = XLSX.utils.json_to_sheet([], { header: fields });
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Template");
    XLSX.writeFile(wb, "Student_Template.xlsx");
    toast.success("Template downloaded successfully!");
  };

  // Handle File Upload
  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) {
      toast.error("Please select a file to upload.");
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target?.result as ArrayBuffer);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const parsedData = XLSX.utils.sheet_to_json<Form>(worksheet);

      if (parsedData.length === 0) {
        toast.error("The uploaded file is empty.");
        return;
      }

      setFormArray(parsedData);
      setStudents(parsedData);
      toast.success("File uploaded successfully!");
    };
    reader.readAsArrayBuffer(file);
  };

  // Handle Form Submit
  const handleSubmit = () => {
    if (formArray.length === 0) {
      toast.error("No data to submit. Please upload a valid Excel file.");
      return;
    }

    setLoading(true);
    const data = formArray.map((item) => {
      return {
        ...item,
        school_id: user.school_id,
        branch_id: selected_branch.branch_id,
        query_type: "create",
      };
    });

    _post("students/bulk?query_type=create", data, (res) => {
      setLoading(false);
      if (res.success) {
        toast.success("Data submitted successfully!");
        setFormArray([]);
        setLoading(false);
      } else {
        toast.error("Submission failed. Please try again.");
        setLoading(false);
      }
    });
  };

  return (
    <div className="row">
        <div className="col-4">
        <button className="btn btn-info" onClick={generateTemplate}><FeatherIcon size={20} icon="download" />{" "}Excel Template  </button></div>
        <div className="col-6">
      <input
        className="form-control"
        type="file"
        accept=".xlsx, .xls"
        onChange={handleFileUpload}
      />
      </div>
      <div className="col-2">
      <button disabled={loading} className="btn btn-success" onClick={handleSubmit}>{loading? <Spinner/>:""} Submit</button>
      </div>
    </div>
  );
};

export default BulkUploadStudents;
